let React      = require("react");

let Footer     = require("../controls/Footer.jsx");
let SiteHeader = require("../controls/SiteHeader.jsx");

const SECTION_NAME = "InvitationNoPending";

class InvitationNoPending extends React.Component {

    constructor(){
        super();

        this.onSearch = this.onSearch.bind(this);
    }

    componentDidMount(){
        googleGA("send", "event", "page invitation no pending", "pageview");
        document.title = `Page invitation no pending | library.io`;
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    render() {
        return  <div className="pageNotFound">
                    <SiteHeader type="Explore" onSearch={this.onSearch}/>
                    <h1 className="pageNotFound__title">Invitation not found</h1>
                    <p className="pageNotFound__description"> It could be that you have already accepted/rejected it, or it could have been canceled by the sender. <br/> </p>
                    <Footer type={SECTION_NAME}/>
                </div>
    }
}

module.exports = InvitationNoPending;
